//@ts-nocheck
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import Router from "@jack-henry/web-component-router";

import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import "@banno/jha-wc/src/forms/jha-form-row/jha-form-row";
import "@banno/jha-wc/src/jha-container/jha-container";
import "@banno/jha-wc/src/tables/jha-table-row/jha-table-row";
import "@banno/jha-wc/src/tables/jha-table-header/jha-table-header";
import "@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell";
import "@banno/jha-wc/src/icons/jha-icon-cards";
import "@banno/jha-wc/src/tables/advanced/jha-advanced-table/jha-advanced-table";

import '@jack-henry/jh-ui/components/input/input.js';

import { Apis } from "../../utils/api-constants";
import { fixedEncodeURIComponent, postRequest } from "../../utils/jha-fetch";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { GlobalConstants } from "../../utils/constants";
import "../../Components/Loader";

import moment from "moment";
import { routerConfig } from "../../routers";
import { decryptValue, getCurrentTimezone, getDateByTimeZone, stringComparison } from "../../utils/app-utils";
import { setUserSessionCookies } from "../../utils/setUserSessionCookies";
import { updateLaunchDarklyUserContext } from "../../utils/launchdarkly-helpers";
import { consumeAndValidateOidcCallback } from "../../utils/oidc-login-state";

@customElement("callback-token")
export class Callback extends LitElement {
  @property({ type: Boolean }) loading = true;
  @property({ type: Object }) tokenData = null;
  @property({ type: Array }) usersData = [];

  @property({ type: Object })
  advancedTableConfig = {
    sort: {
      columnId: 'createDateTime',
      descending: true,
    },
  };
  @property({ type: Boolean })
  apiLoading = false;
  static get styles() {
    return [
      css`
        
        jha-form-text-input {
        min-width: 500px;
        }
        jha-button {
          width: 100%;
        }
        img {
          width: 112px;
          height: 112px;
        }
        #callbackBg {
          background-color: #06185f;
          display: flex;
          align-items: center;          
          width: 100vw;
          padding: 1%;
        }
        
        #avatarDiv {
          display: flex;
          justify-content: center;
          width: 100%;
        }
        #submitBtn {
          width: 90px;
        }
          .padding-top { padding : 48px; } 
           
        .table-scroll-container {
         margin-top: -5%; /* or any smaller value */
        }
      `,
    ];
  }
  @property({ type: Array })
  columns = [
    {
      label: "USER ID",
      id: "userId",
      sortBy: true,
      valueRenderer: (val) => val?.length > 30 ? val.substring(0, 30) + "..." : val,
    },
    {
      label: "NAME",
      id: "fullName",
      sortBy: true,
      valueRenderer: (val) => val?.length > 30 ? val.substring(0, 30) + "..." : val,
    },
    {
      label: "BUSINESS UNIT",
      id: "businessUnit",
      sortBy: true,
    },
    {
      label: "USER ROLE",
      id: "roleType",
      sortBy: true,
      valueFormatter: (val) => stringComparison(val, "readwrite") ? "Read/Write" : stringComparison(val, "readonly") ? "Read Only" : ""
    },
    {
      label: "",
      id: "actionId",
      alignRight: true,
      valueRenderer: (item) => html`
        <jha-button large type="submit" @click=${() => this.selectedUser(item)}
          sync
          ><span style="font-weight:600;">Select</span></jha-button>
      `,
    },
  ].slice();
  async connectedCallback() {
    super.connectedCallback();
    this.removeGridFooter();
    const alreadyFetched = sessionStorage.getItem("callbackTokenFetched");
    if (alreadyFetched === null || alreadyFetched === "false") {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");
      const state = urlParams.get("state");
      const issuer = urlParams.get("iss");
      if (!code || !state || !issuer) {
        sessionStorage.setItem("idpErrorMessage", "Access Denied.");
        const router = new Router(routerConfig);
        router.go("/login");
        return;
      }
      if (!consumeAndValidateOidcCallback({ state, iss: issuer })) {
        sessionStorage.setItem("idpErrorMessage", "Access Denied.");
        const router = new Router(routerConfig);
        router.go("/login");
        return;
      }
      sessionStorage.setItem("callbackTokenFetched", "true");

      try {
        this.loading = true;
        let response = await postRequest(
          Apis.JHID_EXCHANGE_TOKEN,
          { authCode: fixedEncodeURIComponent(code), Issuer: fixedEncodeURIComponent(issuer), state: fixedEncodeURIComponent(state) }
        );

        if (response?.messageStatus === null) {
          this.tokenData = response.token;
          if (response.users.length === 1) {
            this.setUserAndRedirect(response.users[0]);
          } else if (response.users.length > 1) {
            this.usersData = response.users;
            this.loading = false;
          }
          else {
            sessionStorage.setItem("idpErrorMessage", "Access Denied.");
            const router = new Router(routerConfig);
            router.go("/login");
          }
        } else {
          sessionStorage.setItem("idpErrorMessage", "Access Denied.");
          const router = new Router(routerConfig);
          router.go("/login");
        }
      } catch (error) {
        sessionStorage.setItem("idpErrorMessage", "Error during token exchange.");
        const router = new Router(routerConfig);
        router.go("/login");
      }
    }
  }

  removeGridFooter() {
    const interval = setInterval(() => {
      const table = this.renderRoot.querySelector('jha-advanced-table');
      const footer = table?.shadowRoot?.getElementById('footer');

      if (footer && this.usersData.length <= 10) {
        footer.style.display = 'none';
        clearInterval(interval);
      } else if (footer) {
        clearInterval(interval);
      }
    }, 100);
  }

  setUserAndRedirect(user) {
    const onVerifyOtp = {
      token: {
        token: this.tokenData.token,
        refreshToken: this.tokenData.refreshToken,
        expiry: this.tokenData.expiry,
        tokenUserName: this.tokenData.tokenUserName,
        picture: this.tokenData.picture,
      },
      userId: user.userId,
      role: user.role,
      userType: user.userType,
      fullName: user.fullName,
      businessUnit: user.businessUnit,
      email: user.email,
    };
    setUserSessionCookies(onVerifyOtp);
    void updateLaunchDarklyUserContext();
    sessionStorage.removeItem("callbackTokenFetched");
    // Hard navigation: main-element only reads idpCallback/login in connectedCallback.
    // Soft router.go("/users") leaves the callback shell visible until F5.
    window.location.assign("/users");
  }

  selectedUser(userId) {
    const selectedUser = this.usersData.find(u => u.userId === userId);
    if (selectedUser) {
      this.setUserAndRedirect(selectedUser);
    }
  }
  get listData() {
    return this.usersData.map((item) => ({ ...item, ...{ actionId: item.userId } }));
  }
  renderTable() {
    return html`
      <div class="table-scroll-container">
        <jha-advanced-table .tableConfig=${this.advancedTableConfig} .columns=${this.columns} .data=${this.listData}>
        </jha-advanced-table>
      </div>
    `;
  }

  render() {
    if (this.loading) {
      return html`<loader-component></loader-component>`;
    }
    if (this.usersData.length > 1) {
      return html`
      <div id="callbackBg">
        <jha-card class="padding-top">
          <form>
            <div id="avatarDiv">
              <img src="/jha-logo.png" alt="JHA" />
            </div>
            <jha-form-row>
              <div id="avatarDiv">
                <h2>EFM Users</h2>
              </div>
            </jha-form-row>
            <jha-form-row>
              <jha-card>
                ${this.renderTable()}
              </jha-card>
            </jha-form-row>
          </form>
        </jha-card>
      </div>
    `;
    }
  }

}
declare global {
  interface HTMLElementTagNameMap {
    "callback-token": Callback;
  }
}